<a class="link-color flex flex-row justify-start items-center" (click)=openManageMembersDialog()
   particleAnalytics
   analyticsCategory="shared-drive-members-cell-viewer"
   [analyticsAction]="item.cells[fieldDefinition.key]?.displayText">
  <div>
    {{item.cells[fieldDefinition.key]?.displayText}}
  </div>
</a>
